import { useState } from "react"
import YesNoAsk_Modal from "../component/YesNoAsk_Modal"

export const Submit_Attend = ({ edit, disabled, setReload, isSubmitLoading, setIsSubmitLoading }) => {
    //#region variables
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const bodyMessage = 'This is to confirm that the provided information match your records on SONIS. It will be send to your advisor for final confirmation.'


    return <>
        <button
            disabled={disabled}
            className='btn btn-md btn btn-outline-primary' type='button' onClick={() => { setShow(true) }} > Submit Courses </button>
        <YesNoAsk_Modal
            title={'Submission warning'}
            htmlDivElement={''}
            disabled={isSubmitLoading === true}
            btnName={'Confirm & Submit'}
            bodyMessage={bodyMessage}
            responseMessage={'Form submission'}
            variant={'success'}
            handleClose={handleClose}
            setReload={setReload}
            show={show}
            execFunc={() => { }}
            submitFunc={() => edit().then(e => setShow(false))}
        />
    </>
}